// extracted by mini-css-extract-plugin
module.exports = {"boxLists":"_1JotQGw5-03Xn0seeMMR_D","list":"_3bf0ct5orEcIB2PdrNaUlO","name":"_2MyjmUb6KymKTEbZ3CbD3H","manage":"_1Y6_4xkEpeGY79Nmtm6A0U"};